var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundDetailGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 264,
    viewBox: "0 0 137 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136 170.479C158.091 170.479 176 153.033 176 131.513C176 109.992 158.091 92.5459 136 92.5459C113.909 92.5459 96 109.992 96 131.513C96 153.033 113.909 170.479 136 170.479Z",
    stroke: "#B0FFD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 264C211.335 264 272 204.902 272 132C272 59.0984 211.335 0 136.5 0C61.6654 0 1 59.0984 1 132C1 204.902 61.6654 264 136.5 264Z",
    stroke: "#B0FFD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 238.671C196.975 238.671 246 190.913 246 132C246 73.0866 196.975 25.3281 136.5 25.3281C76.0248 25.3281 27 73.0866 27 132C27 190.913 76.0248 238.671 136.5 238.671Z",
    stroke: "#B0FFD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 216.266C184.273 216.266 223 178.539 223 132C223 85.4614 184.273 47.7344 136.5 47.7344C88.7274 47.7344 50 85.4614 50 132C50 178.539 88.7274 216.266 136.5 216.266Z",
    stroke: "#B0FFD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 194.834C172.122 194.834 201 166.702 201 132C201 97.2977 172.122 69.166 136.5 69.166C100.878 69.166 72 97.2977 72 132C72 166.702 100.878 194.834 136.5 194.834Z",
    stroke: "#B0FFD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundDetailGreen);
export default __webpack_public_path__ + "static/media/round-detail-green.56f4115e90ad1b96429e7782277a6211.svg";
export { ForwardRef as ReactComponent };